export const MESSAGE_FORM_EDITOR_LABEL: string = "content text";
